window.addEventListener('alpine:init', bootstrap);

export default () => ({
	gap: 20,
	at_beginning: false,
	at_end: false,
	get current_scroll() {
		return this.$refs.track.scrollLeft;
	},
	get slide_width() {
		return this.$refs.track.firstElementChild.getBoundingClientRect().width;
	},
	get scroll_by() {
		let scroll_by = this.slide_width + this.gap;
		return scroll_by;
	},
	next() {
		const left = this.current_scroll + this.scroll_by;
		this.$refs.track.scrollTo({ left, behavior: 'smooth' });
	},
	prev() {
		const left = this.current_scroll - this.scroll_by;
		this.$refs.track.scrollTo({ left, behavior: 'smooth' });
	}
});

function bootstrap() {
	document.querySelectorAll('.js-carousel').forEach(
		$$ => bootstrapCarousel($$)
	);
}

function bootstrapCarousel($el) {
	$el.setAttribute('x-data', 'carousel');

	const $track = $el.querySelector('.wpb_wrapper');
	if ( $track ) {
		$track.setAttribute('x-ref', 'track');
		$track.setAttribute('x-on:scroll.throttle.50ms', '$dispatch("carousel-scrolled")');
	}

	for (const $slide of $track.children) {
		$slide.setAttribute('x-data', 'carouselItem');
		$slide.setAttribute('x-bind:class', '{ "is-active": is_active }');
		$slide.setAttribute('x-on:carousel-scrolled.window', 'scroll');
		$slide.setAttribute('x-bind', 'track_begin_end_state');
	}

	setupNav($el);
}

function setupNav($el) {
	const $nav = document.createElement('nav');
	$nav.classList.add('c-carousel__nav');

	$nav.insertAdjacentHTML(
		'afterbegin',
		`<button class="c-carousel__control is-prev" :class="{ 'is-disabled': at_beginning }" x-on:click="prev">Previous</button>`
	);
	$nav.insertAdjacentHTML(
		'beforeend',
		`<button class="c-carousel__control is-next" :class="{ 'is-disabled': at_end }" x-on:click="next">Next</button>`
	);

	$el.appendChild($nav);
}
